<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2021-12-19 17:08:40
 * @LastEditors: 诺
 * @LastEditTime: 2022-05-17 13:47:59
-->
<template>
  <div class="model" v-if="data.length != 0" :style="{ backgroundColor: `${rgba(bColor, 0.3)}` }">
    <div class="modelTitle" :style="{ backgroundColor: bColor, color: textColor }">
      {{ title }}
    </div>
    <div class="modelBg">
      <div class="list">
        <div class="item" v-for="(item, index) in data" :key="index" @click="$emit('handleCoupon', item)">
          <div class="itemMain" v-if="item.styleType == 1 && item.winType == 4">
            <div class="itemInfo">
              <div class="typeName">{{ item.type == 4 ? "折扣" : "立减" }}</div>
              <div class="couponTitle">{{ item.name }}</div>
              <div class="couponInfo">{{ item.info }}</div>
            </div>
            <div class="itemIntro">
              <div class="itemIntroBox">
                <div class="reduce" v-if="item.type == 4">
                  <span> {{ item.discount }}</span> 折
                </div>
                <div class="reduce" v-if="item.type == 5">
                  <span> {{ item.reduce }}</span
                  >元
                </div>
                <div class="receive">立即领取</div>
              </div>
            </div>
          </div>

          <div class="itemMain" v-if="item.styleType == 1 && item.winType == 5">
            <div class="itemInfo">
              <div class="couponTitle">{{ item.name }}</div>
              <div class="couponInfo" v-html="item.text"></div>
            </div>
            <div class="itemIntro">
              <div class="itemIntroBox">
                <div class="reduce">
                  ￥<span>{{ item.amount / 100 }}</span>
                </div>
                <div class="receive">一键锁定</div>
              </div>
            </div>
          </div>
          <div class="itemMain" v-if="item.styleType == 2" :style="{ backgroundImage: ` url(${item.img})` }"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import util from "./../../../utils/common";
export default {
  props: ["data", "bColor", "title", "textColor"],
  data() {
    return {};
  },
  watch: {
    data: {
      handler(val) {
        val.map((item) => {
          item.text = item.info.replace(/\n/g, "<br/>");
        });
      },
      deep: true,
    },
  },
  created() {},
  methods: {
    rgba(color, alp) {
      return util.rgbToRgba(color, alp);
    },
  },
};
</script>
<style lang="stylus" scoped>
.model {
  width: 351px;
  margin: 32px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 0.1);
  padding:10px;
  border: 1px solid rgba(255, 255, 255, 0.1);

  .modelTitle {
    position: absolute;
    margin-top: -10px;
    color: white;
    padding: 0 20px;
    line-height: 40px;
    height: 40px;
    text-align: center;
    display: inline-block;
    font-size: 20px;
    font-weight: 600;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 0px 0px 12px 12px;
  }

  .modelBg {
    width: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 7px;

    .list {
      margin: 40px 7px 19px;

       .item {
        margin-bottom: 14px;

        .itemMain {
          min-height: 100px;
          // width: 311px;
          // background-image: url('https://assets.rurushishi.com/activies/activityCenter/assistanceHelp/coupon.png');
          background-position: top center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          display: flex;

          .itemInfo {
            background: linear-gradient(180deg, #28D4FE 0%, #4870FF 75.52%);
            box-shadow: 0px 0px 8px rgba(78, 173, 241, 0.5), inset 0px -1px 0px rgba(58, 154, 255, 0.7), inset 0px 1px 0px rgba(173, 237, 255, 0.5);
            border-radius: 8px;
            width: 270px;
            padding: 29px 70px 29px 20px;
            box-sizing: border-box;
            height: 100%;
            min-height: 100px;
            display: flex;
            flex-direction: column;

            .typeName {
              // margin-top: 18px;
              // margin-left: 20px;
              width: 40px;
              height: 20px;
              text-align: center;
              line-height: 20px;
              background: rgba(255, 255, 255, 0.4);
              border-radius: 4px;
              color: #135DCB;
              font-weight: 600;
              font-size: 12px;
            }

            .couponTitle {
              font-weight: 500;
              font-size: 18px;
              line-height: 24px;
              color: #ffffff;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 180px;
            }

            .couponInfo {
              width: 180px;
              font-size: 12px;
              line-height: 16px;
              color: #ADE3FE;
              margin-top: 2px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

          .itemIntro {
            width: 96px;
            margin: 5px 0 5px -60px;
            background: #E8EDF0;
            border-radius: 0 6px 6px 0;
            box-shadow: 2px 0px 2px rgba(81, 118, 167, 0.5), inset 1px 0px 2px rgba(122, 161, 198, 0.5);
            padding: 5px 5px 5px 2px;
            .itemIntroBox {
              flex: 1;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              // margin:
              width: 100%;
              height: 100%;
              border:1px solid #CCD3D7;
              border-left: none;
              box-sizing: border-box;
              border-radius: 2px;
            }

            .discount,
            .reduce {
              color: #135DCB;
              font-size: 14px;

              span {
                font-family: DIN Alternate;
                font-style: normal;
                font-weight: bold;
                font-size: 32px;
              }
            }

            .receive {
              width: 80px;
              height: 24px;
              margin-top: 5px;
              background: #135DCB;
              border-radius: 12px;
              font-weight: 500;
              font-size: 12px;
              line-height: 24px;
              color: #ffffff;
              text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>
